//export const APP_DOMAIN = "https://chatbot.mobifone.vn/api-v2";
//export const URL_EXPORT = "https://chatbot.mobifone.vn/api-v2";
//export const APP_DOMAIN = "http://103.9.0.237:8083";
//export const URL_EXPORT = "http://103.9.0.237:8083";
// export const APP_DOMAIN = "http://10.3.5.226:8087";
// export const URL_EXPORT = "http://10.3.5.226:8087";
export const APP_DOMAIN = "https://dthgd.mobifone.vn/api";
export const URL_EXPORT = "https://dthgd.mobifone.vn/api";
//export const APP_DOMAIN = "http://10.15.24.50:8888";
//export const URL_EXPORT = "http://10.15.24.50:8888";
export const PATH_LOGIN = "/identity-service/auth/login/";
export const PATH_LOGOUT = "/identity-service/api/auth/logout";
export const PATH_GET_MENU = "/identity-service/site-map/get-tree";
export const PATH_REFRESH_TOKEN = "/identity-service/api/auth/refresh";
export const POST_LOG_ACCESS_PATH = "/identity-service/api/log/access-path";
export const GET_COMMON_USER_INFOR = "/identity-service/auth/get-current-user";

//ChangePassword
export const CHANGE_PASSWORD = "admin/api/change_password";
export const RESET_PASSWORD = "admin/api/reset-password";
export const GET_BREADCRUMB = "admin/api/module/get-bread-crumb";

//export Report Group
export const GET_DATA_REPORT_GROUP = "/report-service/reportGroup/search";
export const CREATE_REPORT_GROUP = "/report-service/reportGroup/create";
export const DELETE_REPORT_GROUP = "/report-service/reportGroup/delete";
export const UPDATE_REPORT_GROUP = "/report-service/reportGroup/update";

//export Report
export const GET_DATA_REPORT = "/report-service/report/search";
export const FIND_REPORT_BY_CODE = "/report-service/report/findByCode";
export const GET_OPTIONS_CONN = "/report-service/report/getOptionsConn";
export const GET_OPTIONS_GROUP = "/report-service/report/getOptionsRPG";
export const GET_TEMPLATE = "/report-service/report/getTemplate";
export const CREATE_REPORT = "/report-service/report/create";
export const DELETE_REPORT = "/report-service/report/delete";
export const UPDATE_REPORT = "/report-service/report/update";
export const GET_DATA_REPORT_PARAMETER = "/report-service/report/parameter/getParam";
export const GET_OPTIONS_API = "/report-service/report/parameter/getOptionsAPI";
export const GET_OPTIONS_REFRESH_BY = "/report-service/report/parameter/getOptionsRefreshBy";
export const UPDATE_REPORT_PARAMETER = "/report-service/report/parameter/update";
export const GET_DATA_API_PARAM = "/report-service/report/parameter/getDataAPIParam";
export const CHECK_POSITION_REPORT_PARAMETER = "/report-service/report/parameter/checkPosition";

//report_template
export const SEARCH_REPORT_TEMPLATE = "/report-service/report-template/search";
export const GET_DESIGN_TEMPLATE_REPORT_TEMPLATE = "/report-service/report-template/get-design-template";
export const CREATE_REPORT_TEMPLATE = "/report-service/report-template/create";
export const DELETE_REPORT_TEMPLATE = "/report-service/report-template/delete";
export const UPDATE_REPORT_TEMPLATE = "/report-service/report-template/update";

//export Connection
export const GET_DATA_CONNECTION = "/report-service/connection/search";
export const CREATE_CONNECTION = "/report-service/connection/create";
export const DELETE_CONNECTION = "/report-service/connection/delete";
export const UPDATE_CONNECTION = "/report-service/connection/update";
export const TEST_CONNECTION = "/report-service/connection/testConnect";

//export API Config
export const GET_DATA_API_CONFIG = "/report-service/reportApi/search";
export const CREATE_API_CONFIG = "/report-service/reportApi/create";
export const DELETE_API_CONFIG = "/report-service/reportApi/delete";
export const UPDATE_API_CONFIG = "/report-service/reportApi/update";

//Báo cáo động
export const GET_PATH_REPORT_PARAM = "/report-service/report/getInfoReport/{reportCode}";
export const POST_PATH_DATA_REFRESH_BY = "/report-service/report/getDataOfParam/{reportCode}";
export const POST_EXPORT_OFFLINE = "/export-report-service/export-report/export-offline/{reportCode}";
export const POST_EXPORT_ONLINE = "/export-report-service/export-report/export-online-buffer/{reportCode}";

//Lịch sử báo cáo
export const GET_OPTIONS_RP_CATEGORY = "/report-service/export-history/getOptionsRpCategory";
export const GET_OPTIONS_REPORT = "/report-service/export-history/getOptionsReport";
export const POST_DATA_EXPORT_HISTORY = "/report-service/export-history/search";
export const GET_DATA_DOWNLOAD_FILE = "/report-service/export-history/download-file-buffer";